module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAASCAYAAAC9+TVUAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAANZJREFUeNpi/D+f4QMDA8MJBtIBHxC/Y0j478MCNiDhvwfJRixglAOSs0BMkCGsUEF2IMmMQ8svoEV/0MQEgPgtUF86C5JgFRAbI/EZgVgQym4C4h1YDP8JxBrIhpwB4ldI/H9A26cT8BTIop9MSALMUK+BMDcQ8wOdykZM8CC7RB/JOxOBrthLbBgjG9IND2QGhu+kRBTCkIT/3xjIBEwMVACjhmA35DeZej8iR7ExMGUWkmGIHDRl/wO5pJ5Ml9wD4g6QQYzAQglk4iQyDeIAYh2AAAMAEo4pQ2sFH5sAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/auth/courseware.png
// module id = 436
// module chunks = 440